import { Component, Inject, OnInit } from "@angular/core";
import { ActivityAdjustmentService } from "../../services/activity-adjustment.service";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PersonService } from "../../services/person.service";
import { WorkplaceService } from "../../services/workplace.service";
import { map, tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { StateService } from "@uirouter/angular";
import { Moment } from "moment";
import { of } from "rxjs/observable/of";

@Component({
    selector: "adjustment",
    template: require('./adjustment.component.html')
})
export class AdjustmentComponent implements OnInit {

    constructor(
        @Inject("id") private id: number,
        private activityAdjustmentService: ActivityAdjustmentService,
        private personService: PersonService,
        private workplaceService: WorkplaceService,
        private fb: FormBuilder,
        private stateService: StateService) { }

    adjustmentObservable: Observable<any>;

    adjustmentForm: FormGroup;

    persons: Observable<Nema.Crew.Model.Person[]>;

    workplaces: Observable<Nema.Crew.Model.Workplace[]>;

    isEdit: boolean;

    isLoading = false;
    isInitialLoad = false;

    get Day() { return this.adjustmentForm.get("Day"); }

    get NumberOfDays() { return this.adjustmentForm.get("NumberOfDays"); }

    get PersonId() { return this.adjustmentForm.get("PersonId"); }

    get WorkplaceId() { return this.adjustmentForm.get("WorkplaceId"); }

    get Comment() { return this.adjustmentForm.get("Comment"); }

    ngOnInit(): void {
        this.adjustmentForm = this.fb.group({
            Day: ['', Validators.required],
            NumberOfDays: ['', Validators.required],
            PersonId: ['', Validators.required],
            WorkplaceId: ['', Validators.required],
            Comment: ['']
        });

        this.isEdit = !!this.id;

        if (this.isEdit) {
            this.isInitialLoad = true;
            this.adjustmentObservable = this.activityAdjustmentService.getActivityAdjustment(this.id).pipe(
                tap(res => {
                    this.adjustmentForm.patchValue(res.body);
                    this.isInitialLoad = false;
                }));
        }
        else {
            this.adjustmentObservable = of(null);
        }

        this.persons = this.personService.getPersons().pipe(map(res => res.body));
        this.workplaces = this.workplaceService.getWorkplaces().pipe(map(res => res.body));
    }

    private readonly listStateName = "app.activities.activityadjustments";

    private readonly listStateNameWithParams = "app.activities.activityadjustments.with-params";

    onSubmit(): void {
        if (this.adjustmentForm.valid) {
            this.isLoading = true;

            const goBackToList = () =>
            {
                this.isLoading = false;
                const m: Moment = this.Day.value;
                this.stateService.go(this.listStateNameWithParams, { year: m.get("year"), month: m.get("month") + 1 });
            };

            if (this.isEdit) {
                this.activityAdjustmentService.updateActivityAdjustment({ ...this.adjustmentForm.value, Id: this.id }).subscribe(goBackToList);
            }
            else {
                this.activityAdjustmentService.createActivityAdjustment(this.adjustmentForm.value).subscribe(goBackToList);
            }
        }
    }

    cancel(): void {
        this.stateService.go(this.listStateName);
    }

    delete(): void {
        this.isLoading = true;

        const goBackToList = () => {
            this.isLoading = false;
            this.stateService.go(this.listStateName);
        };

        this.activityAdjustmentService.deleteActivityAdjustment(this.id).subscribe(goBackToList);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/adjustments/adjustment.component.ts